export const ALL_ITEM_WATCH_PACKAGING = [
    {
      categry: "watchPackaging",
      itemList: [
        {
          itemSelected: "amore",
          itemName: "Amore",
          itemDescription:
            "Amore is a watch packaging, together with the material of your choice, the case is a masterpiece.",
          
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],  itemDesktopBig: [
            "/images/listItem/watchPackaging/Amore/Desktop/700x700px/lussopack-watchpackaging-amore-01.webp",          
            "/images/listItem/watchPackaging/Amore/Desktop/700x700px/lussopack-watchpackaging-amore-02.webp",          
          ],
          itemDesktopSmall: [
            "/images/listItem/watchPackaging/Amore/Desktop/130x130px/lussopack-watchpackaging-amore-01.webp",
            "/images/listItem/watchPackaging/Amore/Desktop/130x130px/lussopack-watchpackaging-amore-02.webp",
          ],
          itemMobileBig: [
            "/images/listItem/watchPackaging/Amore/Mobile/335x335px/lussopack-watchpackaging-amore-01.webp",
            "/images/listItem/watchPackaging/Amore/Mobile/335x335px/lussopack-watchpackaging-amore-02.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/watchPackaging/Amore/Mobile/100x100px/lussopack-watchpackaging-amore-01.webp",
            "/images/listItem/watchPackaging/Amore/Mobile/100x100px/lussopack-watchpackaging-amore-02.webp",
          ],
        },
        {
          itemSelected: "ludovica",
          itemName: "Ludovica",
          itemDescription:
            "Ludovica is a watch case made from high-quality materials and construction, our watch cases are designed to last. Its soft interior lining provides a gentle cushion for your watch, while the sturdy exterior protects it from bumps and scratches.",
          
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],  itemDesktopBig: [
            "/images/listItem/watchPackaging/Ludovica/Desktop/700x700px/lussopack-watchpackaging-ludovica-01.webp",          
            "/images/listItem/watchPackaging/Ludovica/Desktop/700x700px/lussopack-watchpackaging-ludovica-02.webp",          
            "/images/listItem/watchPackaging/Ludovica/Desktop/700x700px/lussopack-watchpackaging-ludovica-03.webp",          
          ],
          itemDesktopSmall: [
            "/images/listItem/watchPackaging/Ludovica/Desktop/130x130px/lussopack-watchpackaging-ludovica-01.webp",
            "/images/listItem/watchPackaging/Ludovica/Desktop/130x130px/lussopack-watchpackaging-ludovica-02.webp",
            "/images/listItem/watchPackaging/Ludovica/Desktop/130x130px/lussopack-watchpackaging-ludovica-03.webp",
          ],
          itemMobileBig: [
            "/images/listItem/watchPackaging/Ludovica/Mobile/335x335px/lussopack-watchpackaging-ludovica-01.webp",
            "/images/listItem/watchPackaging/Ludovica/Mobile/335x335px/lussopack-watchpackaging-ludovica-02.webp",
            "/images/listItem/watchPackaging/Ludovica/Mobile/335x335px/lussopack-watchpackaging-ludovica-03.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/watchPackaging/Ludovica/Mobile/100x100px/lussopack-watchpackaging-ludovica-01.webp",
            "/images/listItem/watchPackaging/Ludovica/Mobile/100x100px/lussopack-watchpackaging-ludovica-02.webp",
            "/images/listItem/watchPackaging/Ludovica/Mobile/100x100px/lussopack-watchpackaging-ludovica-03.webp",
          ],
        },
        {
          itemSelected: "luna",
          itemName: "Luna",
          itemDescription:
            "Luna is a watch case made from high-quality materials and construction, our watch cases are designed to last. Its soft interior lining provides a gentle cushion for your watch, while the sturdy exterior protects it from bumps and scratches.",
          
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],  itemDesktopBig: [
            "/images/listItem/watchPackaging/Luna/Desktop/700x700px/lussopack-watchpackaging-luna-01.webp",          
            "/images/listItem/watchPackaging/Luna/Desktop/700x700px/lussopack-watchpackaging-luna-02.webp",          
            "/images/listItem/watchPackaging/Luna/Desktop/700x700px/lussopack-watchpackaging-luna-03.webp",          
          ],
          itemDesktopSmall: [
            "/images/listItem/watchPackaging/Luna/Desktop/130x130px/lussopack-watchpackaging-luna-01.webp",
            "/images/listItem/watchPackaging/Luna/Desktop/130x130px/lussopack-watchpackaging-luna-02.webp",
            "/images/listItem/watchPackaging/Luna/Desktop/130x130px/lussopack-watchpackaging-luna-03.webp",
          ],
          itemMobileBig: [
            "/images/listItem/watchPackaging/Luna/Mobile/335x335px/lussopack-watchpackaging-luna-01.webp",
            "/images/listItem/watchPackaging/Luna/Mobile/335x335px/lussopack-watchpackaging-luna-02.webp",
            "/images/listItem/watchPackaging/Luna/Mobile/335x335px/lussopack-watchpackaging-luna-03.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/watchPackaging/Luna/Mobile/100x100px/lussopack-watchpackaging-luna-01.webp",
            "/images/listItem/watchPackaging/Luna/Mobile/100x100px/lussopack-watchpackaging-luna-02.webp",
            "/images/listItem/watchPackaging/Luna/Mobile/100x100px/lussopack-watchpackaging-luna-03.webp",
          ],
        },
        {
          itemSelected: "madeline",
          itemName: "Madeline",
          itemDescription:
            "Madeline is a round watch case, perfect for traveling and gifting. It comes with zip around the case.",
          
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],  itemDesktopBig: [
            "/images/listItem/watchPackaging/Madeline/Desktop/700x700px/lussopack-watchpackaging-madeline-01.webp",          
            "/images/listItem/watchPackaging/Madeline/Desktop/700x700px/lussopack-watchpackaging-madeline-02.webp",                  
          ],
          itemDesktopSmall: [
            "/images/listItem/watchPackaging/Madeline/Desktop/130x130px/lussopack-watchpackaging-madeline-01.webp",
            "/images/listItem/watchPackaging/Madeline/Desktop/130x130px/lussopack-watchpackaging-madeline-02.webp",
          ],
          itemMobileBig: [
            "/images/listItem/watchPackaging/Madeline/Mobile/335x335px/lussopack-watchpackaging-madeline-01.webp",
            "/images/listItem/watchPackaging/Madeline/Mobile/335x335px/lussopack-watchpackaging-madeline-02.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/watchPackaging/Madeline/Mobile/100x100px/lussopack-watchpackaging-madeline-01.webp",
            "/images/listItem/watchPackaging/Madeline/Mobile/100x100px/lussopack-watchpackaging-madeline-02.webp",
          ],
        },
        {
          itemSelected: "sole",
          itemName: "Sole",
          itemDescription:
            "Sole watch cases are built to last, made with top-notch materials and construction. The soft interior lining cradles your watch gently, while the sturdy exterior shields it from bumps and scratches.",
          
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],  itemDesktopBig: [
            "/images/listItem/watchPackaging/Sole/Desktop/700x700px/lussopack-watchpackaging-sole-01.webp",          
            "/images/listItem/watchPackaging/Sole/Desktop/700x700px/lussopack-watchpackaging-sole-02.webp",                  
            "/images/listItem/watchPackaging/Sole/Desktop/700x700px/lussopack-watchpackaging-sole-03.webp",                  
          ],
          itemDesktopSmall: [
            "/images/listItem/watchPackaging/Sole/Desktop/130x130px/lussopack-watchpackaging-sole-01.webp",
            "/images/listItem/watchPackaging/Sole/Desktop/130x130px/lussopack-watchpackaging-sole-02.webp",
            "/images/listItem/watchPackaging/Sole/Desktop/130x130px/lussopack-watchpackaging-sole-03.webp",
          ],
          itemMobileBig: [
            "/images/listItem/watchPackaging/Sole/Mobile/335x335px/lussopack-watchpackaging-sole-01.webp",
            "/images/listItem/watchPackaging/Sole/Mobile/335x335px/lussopack-watchpackaging-sole-02.webp",
            "/images/listItem/watchPackaging/Sole/Mobile/335x335px/lussopack-watchpackaging-sole-03.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/watchPackaging/Sole/Mobile/100x100px/lussopack-watchpackaging-sole-01.webp",
            "/images/listItem/watchPackaging/Sole/Mobile/100x100px/lussopack-watchpackaging-sole-02.webp",
            "/images/listItem/watchPackaging/Sole/Mobile/100x100px/lussopack-watchpackaging-sole-03.webp",
          ],
        },
        {
          itemSelected: "stefano",
          itemName: "Stefano",
          itemDescription:
            "Stefano is a watch case made for storing multiple watches. It was made with world-class materials and construction. The exterior is also designed to look classy.",
          
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],  itemDesktopBig: [
            "/images/listItem/watchPackaging/Stefano/Desktop/700x700px/lussopack-watchpackaging-stefano.webp",                       
          ],
          itemDesktopSmall: [
            "/images/listItem/watchPackaging/Stefano/Desktop/130x130px/lussopack-watchpackaging-stefano.webp",
          ],
          itemMobileBig: [
            "/images/listItem/watchPackaging/Stefano/Mobile/335x335px/lussopack-watchpackaging-stefano.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/watchPackaging/Stefano/Mobile/100x100px/lussopack-watchpackaging-stefano.webp",
          ],
        },
      ],
    },
  ];
  